export const isNumeric = (value: string): boolean => /^[0-9\b]+$/.test(value);

export const getOperatingSystem = (): 'iOS' | 'Android' | 'Desktop' => {
    if (/android/i.test(navigator.userAgent)) {
        return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (
        /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints)
    ) {
        return 'iOS';
    }

    return 'Desktop';
};
